import { checkIsLiteStore } from '../storeInfo';
import { checkIsYCP } from './checkIsYCP';

/**
 * Определяет, нужно ли использовать брендинг YCP.
 *
 * Kit Lite сохраняет тему и поведение YCP-кабинета, но использует брендинг KIT.
 *
 * @kind helper
 */
export const checkIsYCPBrand = () => checkIsYCP() && !checkIsLiteStore();
